import {productImsiList} from 'api/productImsi';
import Cookies from 'js-cookie';

const productImsi = {
    state: {
        account: '',
        status: '',
        email: '',
        uid: Cookies.get('uid'),
        acc: Cookies.get('acc'),
        avatar: '',
        introduction: '',
        roles: [],
        setting: {
            articlePlatform: []
        }
    },

    mutations: {

    },

    actions: {
        productImsiList({commit},params) {
            return new Promise((resolve, reject) => {
                productImsiList(params.productId,params.productName, params.agent,params.psize, params.currentPage).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        }
    }
};

export default productImsi;



// WEBPACK FOOTER //
// ./src/store/modules/productImsi.js